import React from 'react';
import { Batiment } from '../../../../shared/types/game';

interface BuildingCellulesTabProps {
  building: Batiment;
  onIncreaseCapacity?: () => void;
}

const BuildingCellulesTab: React.FC<BuildingCellulesTabProps> = ({ building, onIncreaseCapacity }) => {
  const totalCellules = building.capacite || 0;
  const cellulesOccupees = building.postes_occupes || 0;
  const cellulesDisponibles = building.postes_disponibles || 0;
  const isPolice = building.type === 'fdo';
  const isPrison = building.type === 'prison';

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Cellules ({totalCellules})</h3>
        {isPrison && onIncreaseCapacity && (
          <button 
            onClick={onIncreaseCapacity}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            + Augmenter la capacité
          </button>
        )}
        {isPolice && (
          <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors">
            Transférer vers prison
          </button>
        )}
      </div>

      {/* Statistiques */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
          <p className="text-2xl font-bold text-white">{totalCellules}</p>
          <p className="text-sm text-gray-400 mt-1">Total</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
          <p className="text-2xl font-bold text-white">{cellulesOccupees}</p>
          <p className="text-sm text-gray-400 mt-1">Occupées</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
          <p className="text-2xl font-bold text-white">{cellulesDisponibles}</p>
          <p className="text-sm text-gray-400 mt-1">Disponibles</p>
        </div>
      </div>

      {/* Liste des cellules */}
      {totalCellules === 0 ? (
        <div className="text-center py-12 text-gray-400">
          <p className="text-lg mb-2">Aucune cellule disponible</p>
          <p className="text-sm">Les cellules seront créées automatiquement avec les augmentations de capacité</p>
        </div>
      ) : (
        <div className="space-y-3">
          {Array.from({ length: totalCellules }, (_, index) => {
            const celluleNumero = index + 1;
            const isOccupee = index < cellulesOccupees;
            
            return (
              <div
                key={celluleNumero}
                className={`bg-gray-800 border rounded-lg p-4 transition-colors ${
                  isOccupee
                    ? 'border-red-500/50 hover:border-red-500'
                    : 'border-gray-700 hover:border-blue-500'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-white">
                      Cellule #{celluleNumero}
                    </h4>
                    <div className="flex items-center gap-3 mt-2">
                      <span className={`px-2 py-1 rounded text-xs ${
                        isOccupee
                          ? 'bg-red-500/20 text-red-400'
                          : 'bg-green-500/20 text-green-400'
                      }`}>
                        {isOccupee ? (isPolice ? 'En attente de transfert' : 'Occupée') : 'Disponible'}
                      </span>
                      <span className="text-xs text-gray-400">
                        Capacité: 4 places
                      </span>
                      {isPolice && isOccupee && (
                        <span className="px-2 py-1 bg-yellow-500/20 text-yellow-400 rounded text-xs">
                          ⏳ Attente transfert
                        </span>
                      )}
                    </div>
                  </div>
                  <button className="ml-4 text-gray-400 hover:text-white transition-colors">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                    </svg>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BuildingCellulesTab;
